// extracted by mini-css-extract-plugin
export default {"jenga-item":"index_jenga-item__ttSR8","title":"index_title__26lkS","body":"index_body__hFxgr"};